/**
 * Languages the app ships translations for (src/assets/i18n/<lang>.json). Single source for Transloco's
 * availableLangs and the Intl locales. The app runs in DEFAULT_LANG only (no switcher, no detection).
 * scripts/check-i18n.mjs and transloco.config.js read this list from here.
 */
export const SUPPORTED_LANGS = ['es', 'en', 'zh'] as const;

export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

/** Language the app is shown in */
export const DEFAULT_LANG: SupportedLang = 'es';

export function isSupportedLang(lang: unknown): lang is SupportedLang {
	return typeof lang === 'string' && (SUPPORTED_LANGS as readonly string[]).includes(lang);
}
